module.exports = __webpack_public_path__ + "3cacf999f56d1c23a4d044c2e6d56adf.jpg";